import type {
  AvailabilityInfo,
  TileAvailabilityInfo
} from '../../constants/props';

export default function calculateSoonestAvailable({
  pickup,
  delivery
}: TileAvailabilityInfo): Partial<AvailabilityInfo> {
  if (pickup == null) return delivery ?? {};

  if (delivery == null) return pickup;

  if (pickup.drivingMiles > 150) return delivery;

  return delivery.daysToAvailability < pickup.daysToAvailability
    ? delivery
    : pickup;
}
